<template>
  <v-app>
    <app-snackbar
    :text = "snackBarText"
    :show.sync = "snackbar"
    :color = "snackbarColor"
    :timeOut = "timeOut"
    ></app-snackbar>
    <v-container class="signin">
      <v-layout row>
        <v-flex xs12 sm4 offset-sm4>
          <v-container class="medium-div">
            <v-container class="without-padding container-img">
              <v-img :src="require('../../assets/logoPonce.png')"/>
            </v-container>
            <p class="text-title">¡{{$t('Signin.setAccountData')}}!</p>
            <form @submit.prevent="onSignin">
              <v-layout row>
                <v-text-field class="input-email"
                  prepend-inner-icon="mail"
                  name="email"
                  :label="$t('Signin.email')"
                  id="email"
                  v-model="email"
                  type="email"
                  color="#00202F"
                  :rules="$ponceConfig.emailRules"
                  validate-on-blur
                  required></v-text-field>
              </v-layout>
              <v-layout row>
                <v-text-field class="input-password"
                  prepend-inner-icon="lock"
                  name="password"
                  :label="$t('Signin.password')"
                  id="password"
                  v-model="password"
                  type="password"
                  color="#00202F"
                  :rules="$ponceConfig.passwordRules"
                  validate-on-blur
                  required></v-text-field>
              </v-layout>
              <v-layout v-if="showError" row>
                <p class="error-text">{{$t('Signin.wrongSigninDataHint')}}</p>
              </v-layout>
              <v-layout class="div-reset-password" row>
                <a @click="passRecovery" class="text-reset-password">{{$t('Signin.forgotPassword')}}</a>
              </v-layout>
              <v-layout row style="padding-top:10px">
                <v-flex xs12>
                  <div class="text-center">
                    <v-btn class="submit-btn" block color="info" type="submit" :loading="loading">
                    {{$t('Signin.enter')}}</v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </form>
            <div class="bottom-div">
              <p class="bottom-text">PONCE</p>
            </div>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
  import {auth} from '@/plugins/firebase'
  export default {
    data () {
      return {
        dialog: false,
        email: '',
        password: '',
        snackbar: false,
        snackBarText: '',
        snackbarColor: '',
        showError: false,
        timeOut: 5000,
        loading: false
      }
    },
    methods: {
      passRecovery () {
        this.$router.push({name: 'PassRecovery'})
      },
      async onSignin () {
        if (!this.$store.getters.isOnline) {
          this.snackbar = true
          this.snackBarText = this.$t('Signin.noConnection')
          this.snackbarColor = 'red'
          return
        }
        this.showError = false
        try {
          this.loading = true
          const user = await auth.signInWithEmailAndPassword(this.email, this.password)
          this.$store.dispatch('autoSignIn', user)
          this.$router.push({name: 'LoadingScreen'})
        } catch (error) {
          this.showError = true
        } finally {
          this.loading = false
        }
      },
      saveUserData (id, email, token) {
        localStorage.setItem('auth_token', token)
        this.$root.$data.userId = id
        this.$store.dispatch('signUserIn', { id, email, token })
      },
      onResetPassword () {
        if (this.email === '') {
          return this.$store.dispatch('setError', {message: this.$t('Signin.emailNotBeEmpty')})
        }
        this.$store.dispatch('resetPasswordWithEmail', {email: this.email})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Signin.vue?380b4919